import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-summary-loader',
  templateUrl: './hotel-summary-loader.component.html',
  styleUrls: ['./hotel-summary-loader.component.scss']
})
export class HotelSummaryLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
